export const BSC_SCAN_URL = 'https://bscscan.com/address/';
export const CHAIN_ID = 56;
export const RPC_URL_56 = 'https://bsc-dataseed1.binance.org';
export const POLLING_INTERVAL = 12000;